Ext.ns('mx.data');

mx.data.Record = function(config) {
    Ext.apply(this, config);

    if (this.id || this.id === 0) {
        this.origId = this.id;
    }
    Ext.data.Record.call(this);
};

mx.data.Record.create = function(fields, storeUrl) {
    // Allow field types like mx.data.Order
    Ext.each(
        fields,
        function(f) {
            if (this.isLinkedRecord(f)) {
                f.convert = function(v) {
                    var type = arguments.callee.dataType;

                    // Delayed initialization of linked record constructor
                    if (typeof type == 'string') {
                        if (type.indexOf('[]') == type.length - 2) {
                            // Array types
                            type = type.substr(0, type.length - 2);
                            arguments.callee.isArray = true;
                        } else {
                            // Regular types
                            arguments.callee.isArray = false;
                        }

                        type = arguments.callee.dataType = eval(type);
                    }

                    if (arguments.callee.isArray) {
                        var result = [];
                        if (!Ext.isEmpty(v)) {
                            Ext.each(
                                v,
                                function(i) {
                                    if (!Ext.isEmpty(i)) {
                                        type.prototype.fields.each(function(f) {
                                            var val = i[f.name];
                                            if (val) {
                                                i[f.name] = f.convert(i[f.name]);
                                            }
                                        });
                                        result.push(new type(i));
                                    }
                                },
                                this
                            );
                        }
                        return result;
                    } else {
                        var obj = null;
                        if (!Ext.isEmpty(v)) {
                            var el = v;
                            type.prototype.fields.each(function(f) {
                                var val = el[f.name];
                                if (val) {
                                    el[f.name] = f.convert(el[f.name]);
                                }
                            });
                            obj = new type(el);
                        }
                        return obj;
                    }
                };
                f.convert.dataType = f.type;
                f.type = 'auto';
            } else if (this.isTimeField(f)) {
                f.convert = function(v) {
                    return v ? mx.Util.getServerDate(v) : v;
                };
                f.convert.dataType = f.type;
                f.type = 'auto';
            }
        },
        this
    );

    var r = Ext.data.Record.create(fields);

    r.prototype.toString = function() {
        return this.get('id');
    };

    r.prototype.getData = function(isJson) {
        var result = {};
        var getDataSingular = function(val) {
            if (val && typeof val == 'object' && val['getData']) {
                //it is instance of Record
                return val.getData(isJson);
            } else {
                return val && val.getTime
                    ? isJson
                        ? val.getTime() - mx.Util.browserDateShift
                        : new Date(val.getTime() - mx.Util.browserDateShift)
                    : val;
            }
        };
        for (var k in this.data) {
            var val = this.data[k];
            if (val && typeof val == 'object' && val['length']) {
                result[k] = [];
                val.forEach(function(item) {
                    result[k].push(getDataSingular(item));
                });
            } else {
                result[k] = getDataSingular(val);
            }
        }
        return result;
    };

    r.newStore = function(config) {
        var conf = config || {};
        Ext.apply(conf, {
            record: r,
            url: conf.url || storeUrl,
        });
        return new mx.data.Store(conf);
    };

    return r;
};

mx.data.Record.isTimeField = function(f) {
    return (
        f.type == 'date' &&
        //date format may be any format string, for example: "m/d/Y H:i:s O"
        (!f.dateFormat || f.dateFormat == 'time' || f.dateFormat == 'timestamp')
    );
};
mx.data.Record.isLinkedRecord = function(f) {
    return f.type && f.type.indexOf('mx.data') == 0;
};
mx.data.Record.isLinkedRecordArray = function(f) {
    return mx.data.Record.isLinkedRecord(f) && f.type.indexOf('[]') == f.type.length - 2;
};

mx.data.Record.getName = function(v) {
    var res = v && v.get('name');
    return Ext.util.Format.htmlEncode(res);
};

mx.data.Record.getValuesNames = function(value) {
    if (Ext.isArray(value)) {
        return value
            .map(function(v) {
                return mx.data.Record.getName(v);
            })
            .join(',');
    } else {
        return mx.data.Record.getName(value);
    }
};

Ext.data.Record.prototype.getRecordId = function() {
    return this.get(this.getIdKey());
};

Ext.data.Record.prototype.getIdKey = function() {
    return 'id';
};

Ext.data.Record.prototype.getNameKey = function() {
    return 'name';
};

Ext.data.Record.prototype.getName = function() {
    return Ext.util.Format.htmlEncode(this.get(this.getNameKey()));
};
